import formatTime from "../hooks/formatTime";
import "../../styles/NavigatorCodeBoardLogo.css"
import { useTimerState } from "../../TimerContext";
type RenderBoardLogoProps = {
  isGameStarted: boolean;
  isGameFinished: boolean;
  onStart: () => void;
  onNext: () => void;
};
type BoardButtonProps = {
  isGameStarted: boolean;
  isGameFinished: boolean;
  onStart: () => void;
  onNext: () => void;
};
const BoardButton = ({
  isGameStarted,
  isGameFinished,
  onStart,
  onNext,
}: BoardButtonProps) => {
  if (!isGameStarted) {
    return (
      <button
        title="Начать игру"
        className="navigatorСode-buttonCheck"
        onClick={() => {
          onStart();
        }}
      >
        Начать игру
        <img
          alt=""
          className="navigatorСode-logoRun"
          src="/img/button/run-fix.svg"
        />
      </button>
    );
  }
if(isGameFinished){
  return (
    <button className="navigatorСode-buttonCheck" onClick={onNext}>
      Играть ещё
      <img alt="" className="navigatorСode-logoRun" src="/img/button/run-fix.svg" />
    </button>
  );
}
return null;
};
const RenderBoardLogo: React.FC<RenderBoardLogoProps> = ({
   isGameStarted,
  isGameFinished,
  onNext,
  onStart,
}) => {
   const { time, isTimerRunning } = useTimerState();
  return (
    <div className="navigatorСode-board-logo">
      <img
        alt="logo"
        src="/img/transpos/person-transpos.svg"
        className="navigatorСode-board-logo-image"
      ></img>

      <p className="navigatorСode-subtitle" id="navigatorСode-subtitle-board-logo">
        {isGameStarted && `Таймер: ${formatTime(time)}`}
      </p>
      <div id="navigatorСode-board-logo-button">
        {!isTimerRunning && (
          <BoardButton
            isGameStarted={isGameStarted}
            isGameFinished={isGameFinished}
            onStart={onStart}
            onNext={onNext}
          />
        )}
      </div>
    </div>
  );
};
export default RenderBoardLogo;